// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".applicant-name{line-height:1.3rem;padding:.6rem 0}.applicant-name span{display:block}.subtab .el-tabs .el-tabs__active-bar{display:none}.subtab .el-submenu .el-menu-item{min-width:auto}.subtab .el-submenu .el-submenu__title{display:flex;align-items:center}.subtab .el-tabs__nav{width:100%}.subtab .el-tabs__nav .el-tabs__item{width:100%;padding:0 1rem!important}.el-menu-item.is-active{color:#7100da;font-weight:800}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
